import {
  inject,
  EnvironmentInjector,
} from '@angular/core';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { firstValueFrom } from 'rxjs';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from '@angular/router';
import { ConfigService } from '../../../../../my-shared-lib/src/lib/shared-services/config.service';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const injector = inject(EnvironmentInjector);

  const router = injector.get(Router);
  const roleService = injector.get(ConfigService);
  const keycloak = injector.get(Keycloak);

  const { authenticated } = authData;
  const user = keycloak.tokenParsed;
  const email = user?.['email'];

  try {
    const role = await firstValueFrom(roleService.getRole(email));
    const allowedPaths = await firstValueFrom(roleService.getMenu(role));
    const currentPath = normalizePath(state.url);

    const hasAccess = allowedPaths.some((path: string) => normalizePath(path) === currentPath);

    if (authenticated && hasAccess) {
      return true;
    }
    return router.parseUrl('/not-found');
  } catch (error) {
    console.error('Guard check failed:', error);
    return router.parseUrl('/not-found');
  }
};

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);

function normalizePath(path: string): string {
  const cleanPath = String(path || '').split('?')[0].split('#')[0].trim();
  return cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
}
